var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.task_page_obj!=null)?_c('task-page',{attrs:{"prop_task_page_obj":_vm.task_page_obj,"prop_user_sites":_vm.userSites,"prop_user":_vm.login_user_name,"prop_user_roles":_vm.userRoles}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd2dc0ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/task-management/TaskMasterPage.vue
// module id = null
// module chunks = 